import * as Sentry from '@sentry/nextjs';
import { NextPageContext } from 'next';
import NextErrorComponent, { ErrorProps as NextErrorProps } from 'next/error';

import ErrorPage404 from './404';
import ErrorPage500 from './500';

type ErrorPageProps = NextErrorProps & {
  error: Error | null;
};

function ErrorPage(props: ErrorPageProps) {
  if (props.statusCode === 404) return <ErrorPage404 />;

  return <ErrorPage500 error={props.error} />;
}

ErrorPage.getInitialProps = async (
  context: NextPageContext
): Promise<ErrorPageProps> => {
  // In case this is running in a serverless function, await this in order to give Sentry time to send the error before the lambda exits
  await Sentry.captureUnderscoreErrorException(context);

  // This will contain the status code of the response
  const nextProps = await NextErrorComponent.getInitialProps(context);

  return {
    ...nextProps,
    error: context.err || null,
  };
};

export default ErrorPage;
